import AppleTouchIconPngUrl from "@iyk/ui/assets/apple-touch-icon.png?url"
import FaviconSvgUrl from "@iyk/ui/assets/favicon.svg?url"

import { Dialog as BaseDialog } from "@base-ui/react/dialog"

// @iyk/music-ui components
export * from "./components/Alert"
export * from "./components/ArtistAvatarName"
export * from "./components/AuthLayout"
export * from "./components/BaseUIWrapper"
export * from "./components/Card"
export * from "./components/Dialog"
export * from "./components/Drawer"
export * from "./components/DrawerDropdown"
export * from "./components/FeedMediaController"
export * from "./components/forms/Checkbox"
export * from "./components/forms/CheckboxField"
export * from "./components/forms/Combobox"
export * from "./components/forms/file/File"
export * from "./components/forms/file/UploadType"
export * from "./components/forms/file/useSingleUpload"
export * from "./components/forms/FormCard"
export * from "./components/forms/RadioGroup"
export * from "./components/forms/Switch"
export * from "./components/forms/TextField"
export * from "./components/forms/UrlField"
export * from "./components/GalleryUnlockBadge"
export * from "./components/InputOtp"
export * from "./components/LottiePlayer"
export * from "./components/MediaCarousel"
export * from "./components/MediaDialog"
export * from "./components/Meta"
export * from "./components/ScrollArea"
export * from "./components/Sheet"
export * from "./components/Tabs"
export { ToastAction } from "./components/Toast"
export * from "./components/UserMenu"
export * from "./components/VerifiedBadge"
export * from "./components/VideoPlayer"
export * from "./components/WorldProfileBanner"
export * from "./components/WorldProfileFooter"

// @iyk/music-ui hooks
export * from "./hooks/useDerivedState"
export * from "./hooks/useIntersectionObserver"
export * from "./hooks/useMediaQuery"
export * from "./hooks/useToast"

// @iyk/music-ui icons
export * as MusicIcon from "./icons"

export const Primitive = {
  Dialog: BaseDialog
}

// @iyk/ui components
export {
  Avatar,
  Badge,
  BlinkingCursor,
  Breadcrumbs,
  Button,
  ButtonGroup,
  CarouselV2 as Carousel,
  DescriptionList,
  Dropdown,
  Field,
  Fieldset,
  Icon,
  Label,
  LinesShader,
  Link,
  Pixelation,
  Select,
  Sidebar,
  Textbox,
  TextboxAffix,
  Validity
} from "@iyk/ui"

// @iyk/ui classes
export { classForButton, classForLink } from "@iyk/ui"

// @iyk/ui utilities
export {
  acceptImagesFileType,
  acceptStillImagesFileType,
  acceptVideosFileType,
  cva,
  cx,
  defaultAvatarSVG
} from "@iyk/ui"

// @iyk/ui assets
export const Assets = { AppleTouchIconPngUrl, FaviconSvgUrl }
